import Api from './api.service';

export default {
  get: (params = {}) => Api.get('procedures', { params }),
  getId: (id) => Api.get(`procedures/${id}`),
  store: (procedure) => Api.post('procedures', procedure),
  update: (id, data) => Api.put(`procedures/${id}`, data),
  destroy: (id) => Api.delete(`procedures/${id}`),
};
